import { login} from '@/api/api'
import {useMutitabsStore} from "@/store/mutitabs";
import {setStorage,getStorage} from '@/utils/util'
  
function getMenu(nextTick,router) {
        const mutitabsstore = useMutitabsStore()
        let allmenu=[]
      
        //前端构建菜单列表
        let menuTree = []

     
         let munue_data = []
      
        const munue_data_home    = {"id":"244b28685cd14a39a383189981510d4b",    "modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"homePage",          "title":"首页&大屏","menuPermission":["Update","Disable","Search","Create","Retrieve","Delete"], "description":null,"modifier":null,"dept_belong_id":null,"icon":"homeFilled",    "name":"首页&大屏","sort":1,"is_link":0,"web_path":"homePage",        "component":null,                     "component_name":null,          "status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":null}
        const munue_data_alarm   = {"id":"54f769b0-3dff-416c-8102-e55ec44827cc","modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"alarmsManage",      "title":"故障告警", "menuPermission":["Update","Search","Create","Retrieve","Delete"],           "description":null,"modifier":null,"dept_belong_id":null,"icon":"WarningFilled", "name":"事件中心", "sort":2,"is_link":0,"web_path":"alarmsManage",    "component":null,                     "component_name":null,          "status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":null}
        const munue_data_manage  = {"id":"c236fb6b-ddaa-4deb-b79b-16e42d9f347f","modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"deviceManage",      "title":"设备管理", "menuPermission":["Update","Search","Create","Retrieve","Delete"],           "description":null,"modifier":null,"dept_belong_id":null,"icon":"",         "name":"设备管理", "sort":3,"is_link":0,"web_path":"deviceManage",    "component":null,                     "component_name":null,          "status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":null}
        const munue_data_monitor = {"id":"244b28685cd14a39a383189981510d4c",    "modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"deviceMonitoring",  "title":"设备监测", "menuPermission":["Update","Disable","Search","Create","Retrieve","Delete"], "description":null,"modifier":null,"dept_belong_id":null,"icon":"TrendCharts",   "name":"设备监测", "sort":4,"is_link":0,"web_path":"deviceMonitoring","component":null,                     "component_name":null,          "status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":null}
        const munue_data_net     = {"id":"244b28685cd14a39a383189981510d4d",    "modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"gatewayConfigure",  "title":"网关配置", "menuPermission":["Update","Disable","Search","Create","Retrieve","Delete"], "description":null,"modifier":null,"dept_belong_id":null,"icon":"Connection",   "name":"网关配置", "sort":5,"is_link":0,"web_path":"gatewayConfigure","component":null,                     "component_name":null,          "status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":null}
        const munue_data_system  = {"id":"49160b589f004e44b3920c82583c2581",    "modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"systemSetting",     "title":"系统设置", "menuPermission":["Update","Disable","Search","Create","Retrieve","Delete"], "description":null,"modifier":null,"dept_belong_id":null,"icon":"tools",   "name":"系统设置", "sort":6,"is_link":0,"web_path":"systemSetting",   "component":null,                     "component_name":null,          "status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":null}
        
        const munue_data_config = { 
        "id": "c236fb6b-ddaa-4deb-b79b-16e42d9f347f", 
        "modifier_name": null, 
        "creator_name": null, 
        "create_datetime": "2023-11-24 20:14:01",
        "update_datetime": "2023-11-24 20:14:01", 
        "path": "configManage", "title": "系统日志",
         "menuPermission": ["Update", "Disable", "Search", "Create", "Retrieve", "Delete"], 
         "description": null, "modifier": null, 
         "dept_belong_id": null, "icon": "info-filled", 
         "name": "系统日志", "sort": 999, "is_link": 0,
          "web_path": "configManage", "component": null, 
          "component_name": null, "status": 1, "isautopm": 0, 
          "cache": 0, "visible": 1, "creator": null, "parent": "77edf447326b4e0dbc6f9719c1de8a12" }
        
        const munue_tool_system = {"id":"77edf447326b4e0dbc6f9719c1de8a12","modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"","title":"系统工具","menuPermission":[],"description":null,"modifier":null,"dept_belong_id":null,"icon":"","name":"系统工具","sort":990,"is_link":0,"web_path":"","component":null,"component_name":null,"status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":null}
        const munue_ops_system = {"id":"4ba07859-bcbeeee5c91a4e2ea2c2a31237e33616","modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"","title":"系统运维","menuPermission":[],"description":null,"modifier":null,"dept_belong_id":null,"icon":"","name":"系统运维","sort":990,"is_link":0,"web_path":"opsManage","component":null,"component_name":null,"status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent": "77edf447326b4e0dbc6f9719c1de8a12"}
        const munue_check_system =  {"id":"15c9ebc5-d12f-470a-a560-938a7dc57570","modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"","title":"巡检中心","menuPermission":["Update","Search","Changepassword"],"description":null,"modifier":null,"dept_belong_id":null,"icon":"","name":"巡检中心","sort":13,"is_link":0,"web_path":"","component":null,"component_name":null,"status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":null} 
        const munue_rules_system = {"id":"80a340eae92b430abe17635468c2df1d","modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"rulesSet","title":"规则引擎","menuPermission":["Update","Search","Create","Retrieve","Delete"],"description":null,"modifier":null,"dept_belong_id":null,"icon":"","name":"规则引擎","sort":12,"is_link":0,"web_path":"rulesSet","component":null,"component_name":null,"status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":null}
        
        const munue_checkrecord_system =  {"id":"4ba07859-8b73-4524-a1a6-bbff36d98337","modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"inspectionCenter","title":"巡检记录","menuPermission":["Update","Search","Changepassword"],"description":null,"modifier":null,"dept_belong_id":null,"icon":"WarningFilled","name":"巡检记录","sort":13,"is_link":0,"web_path":"inspectionCenter","component":null,"component_name":null,"status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":'15c9ebc5-d12f-470a-a560-938a7dc57570'} 
        const munue_checkmanage_system  = {"id":"c236fb6b-ddaa-4deb-b79b-16e42d9f347f","modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"inspectionManage",      "title":"设备管理", "menuPermission":["Update","Search","Create","Retrieve","Delete"],           "description":null,"modifier":null,"dept_belong_id":null,"icon":"",         "name":"设备管理", "sort":3,"is_link":0,"web_path":"inspectionManage",    "component":null,                     "component_name":null,          "status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":'15c9ebc5-d12f-470a-a560-938a7dc57570'}
        const munue_users_system = {"id":"d73f73a399af48cea6a8490ac508d7a0","modifier_name":null,"creator_name":null,"create_datetime":"2023-11-24 20:14:01","update_datetime":"2023-11-24 20:14:01","path":"userManage","title":"用户管理","menuPermission":["Update","Disable","Search","Create","Retrieve","Delete"],"description":null,"modifier":null,"dept_belong_id":null,"icon":"user-filled","name":"用户管理","sort":7,"is_link":0,"web_path":"userManage","component":null,"component_name":null,"status":1,"isautopm":0,"cache":0,"visible":1,"creator":null,"parent":null}
       
        let roleValue = getStorage("role");
        
        
        if(roleValue != null && (roleValue == 1 || roleValue == 0)){
          munue_data.push(munue_data_home)
          munue_data.push(munue_data_alarm)
          munue_data.push(munue_data_manage)
          munue_data.push(munue_data_monitor)
          munue_data.push(munue_check_system)
          munue_data.push(munue_checkmanage_system)
          munue_data.push(munue_checkrecord_system)
        
          munue_data.push(munue_rules_system)
          munue_data.push(munue_data_net)
          munue_data.push(munue_data_system)
          munue_data.push(munue_data_config)
          munue_data.push(munue_tool_system)
          munue_data.push(munue_ops_system)
          munue_data.push(munue_users_system)
        
          
        }else{
          munue_data.push(munue_data_home)
          munue_data.push(munue_data_alarm)
          munue_data.push(munue_data_monitor)
          munue_data.push(munue_check_system)
        
          munue_data.push(munue_checkrecord_system)
          
        }  

        let childrenList = munue_data.filter(item=> item.parent && item.visible == 1)
        let parentList = munue_data.filter(item=> !item.parent && item.visible == 1)
        if(parentList.length >0) {
          parentList.forEach(item=>{
            let menuTreeChildren=[]
            let children = childrenList.filter(itema=>itema.parent == item.id)
            let children2 = childrenList.filter((item)=>{
              return children.every((item1)=>{
                  return item.path != item1.path;
              })
            })
            children.forEach(itemb=>{
              let cmenuTreeChildren=[]
              let cchildren = children2.filter(itemc=>itemc.parent == itemb.id)
              cchildren.forEach(itemd=>{
                  cmenuTreeChildren.push(({
                    text:itemd.name,
                    id:itemd.id,
                    attributes:{
                      url:itemd.web_path,
                      icon:itemd.icon
                    },
                    hasChildren: false,
                    hasParent:true
                  }))
              })
              let chasChildren = false
              if(cmenuTreeChildren.length>0){
                  chasChildren = true
              }
              menuTreeChildren.push(({
                text:itemb.name,
                id:itemb.id,
                attributes:{
                  url:itemb.web_path,
                  icon:itemb.icon
                },
                children:cmenuTreeChildren,
                hasChildren: chasChildren,
                hasParent:true,
              }))
            })
            menuTree.push({
              text:item.name,
              id:item.id,
              attributes:{
                url:children.length >0 ? children[0].web_path :item.web_path,
                icon:item.icon
              },
              hasChildren: children.length >0,
              hasParent:false,
              children:menuTreeChildren,
            })
            item.children=[...children]
          })
        }

        // 操作权限管控
        let menuList=[]
        munue_data.forEach(item=>{
          //console.log(item,'item---- 菜单权限---')
          menuList.push({
            url:item.web_path,
            moduleName:item.name,
            menuPermission:item.menuPermission
          })
        })
        setStorage('menuList', JSON.stringify(menuList))

        // console.log(menuTree,'menuTree-----')
        allmenu =  menuTree
        if(allmenu.length >0) {
          nextTick(()=>{
           router.replace({path: `/${allmenu[0].attributes.url}`})
          }) 
          
          
        } else {
           mutitabsstore.logout('false')
           router.push({path: '/login'})
           sessionStorage.clear()
           localStorage.clear()
        }
        setStorage('allmenu', JSON.stringify(allmenu))
        //优化首次登录第一个标签显示问题
        let tabsPage = ""
        let TabsValue = ""
        if(menuTree[0].hasChildren){
            tabsPage = [{"title":menuTree[0].children[0].text,"name":menuTree[0].children[0].attributes.url,"query":{}}]
            TabsValue = menuTree[0].children[0].attributes.url
        }else{
            tabsPage = [{"title":menuTree[0].text,"name":menuTree[0].attributes.url,"query":{}}]
            TabsValue = menuTree[0].attributes.url
        }
        mutitabsstore.firstTabs([tabsPage,TabsValue])

      }

async  function submitForm(user,password)  {
         const mutitabsstore = useMutitabsStore()
         let loginInfo = {
               name:user,
               password:password
            }
          const res = await login(loginInfo)
          console.log('登录的信息返回',res)
         if (res.data.code === 10000) {
            if(res.data.data.role != null){
                mutitabsstore.setRole( res.data.data.role );
                let roleValue = getStorage("role");
                console.log("roleValue:" + roleValue);
            }else{
                this.mutitabsstore.setRole(-1);
                let roleValue = getStorage("role");
                console.log("roleValue:" + roleValue);                  
            }
            mutitabsstore.setLogintoken(user + "_1")
            mutitabsstore.setUserName(user)
            mutitabsstore.setUserId(user+ "_2")
            mutitabsstore.setRefresh(user + "_3")
            return {
                msg:"登录成功"
            }
            } else {
            
            this.$message.error(res.data.msg)
            return false
            }
      }
export async function noLogin(user,password,nextTick,router){
        console.log("登录返回结果cccc",user,password)
      const res = await submitForm(user,password)
    
      if(res.msg == "登录成功"){
           getMenu(nextTick,router)
      }
      return 'success'
    
}

 